import { atom } from 'jotai'

// スピナー、フラッシュメッセージ
export const spinnerAtom = atom(false)
export const messageAtom = atom(null)


// 情報検索画面の検索条件
export const searchCondInit = {
    キーワード : '',
    地域 : '',
    上場 : false,
    業種 : '',
    カテゴリー : [],
}
export const searchCondAtom = atom(searchCondInit)

// 検索条件をURLパラメーター化
export const condParamAtom = atom((get) => {
    const cond = get(searchCondAtom)
    const params = Object.keys(cond)
        .filter(c => Array.isArray(cond[c]) ? cond[c].length : cond[c])
        .map(c => `${c}=${Array.isArray(cond[c]) ? cond[c].join(',') : c === '上場' ? cond[c] : cond[c].trim()}`).join('&')
    return  params  ? `?${params}` : ''
})

// 情報検索画面の検索トリガー
export const searchTriggerAtom = atom(true)

// 閲覧履歴の記事読み込み完了トリガー
export const loadedAtom = atom(false)

// 閲覧履歴の企業情報読み込み完了トリガー
export const loadedComAtom = atom(false)

